import React, { useState, useEffect } from 'react';
import { FaPlus, FaSave, FaEdit, FaTrash } from "react-icons/fa";
import CompanyDropdown from "../../DropDowns/CompanyDropdown/CompanyDropdown";
import ISODropdown from "../../DropDowns/ISODropdown/IsoDropdown";
import ParticipantStatusDropdown from "../../DropDowns/ParticipantStatusDropdown/ParticipantStatusCode";
import Dialog from "../FormDialog/Dialog"; 
import { getUserInfo } from "../../../services/authService-sighup";
import { PARTICIPANT_TAB } from '../constants/constants';
interface ParticipantFormProps {
  onCreateParticipant: (participant: any) => void;
  onSaveParticipant: (participant: any) => void;
  companies: string[];
  iso: string[];
  selectedParticipant: any | null;
  onClearSelection: () => void;
  onDirtyChange: (dirty: boolean) => void;
  onModeChange: (mode: 'create' | 'edit' | 'view' | null) => void;
  registerTabSwitchGuard?: (guard: () => boolean | Promise<boolean>) => void;
  onDeleteParticipant: (participantId: string) => void;
  canDelete?: boolean;
}

const ParticipantForm: React.FC<ParticipantFormProps> = ({
  onCreateParticipant,
  onSaveParticipant,
  companies,
  iso,
  selectedParticipant,
  onClearSelection,
  onDirtyChange,
  onModeChange,
  registerTabSwitchGuard,
  onDeleteParticipant,
  canDelete = false,
}) => {
  const [participantLabel, setParticipantLabel] = useState('');
  const [participant_id, setParticipant_id] = useState('');
  const [company_id, setCompany_id] = useState('');
  const [selectedCompany, setSelectedCompany] = useState('');
  const [accountName, setAccountName] = useState('');
  const [selectedIso, setSelectedIso] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [activeField, setActiveField] = useState<string | null>(null);
  const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>({});
  const [formState, setFormState] = useState({
    participantName: '',
    companyId: '', // store company_id
    isoCode: ''
  });
  const [errors, setErrors] = useState({
      company_id: false,
      participantLabel: false,
      accountName: false,
      selectedIso: false,
      selectedStatus:false,
    });

    // console.log('Edit Mode:', isEditMode); 
    const validateFields = () => {
      const newErrors = {
        company_id: !company_id,
        participantLabel: !participantLabel,
        selectedIso: !selectedIso.trim(),
        selectedStatus: !selectedStatus.trim(),
        accountName:!accountName.trim(),
      };
    
      setErrors(newErrors);
      return !Object.values(newErrors).some((error) => error);
    };
  const [user, setUser] = useState<{ fullName: string; email: string } | null>(null);
  
  useEffect(() => {
    if (selectedParticipant) {
      setFormState({
        participantName: selectedParticipant.participant_name,
        companyId: selectedParticipant.account_id,
        isoCode: selectedParticipant.iso_code
      });
    }
  }, [selectedParticipant]);
  // useEffect(() => {
  //   if (!selectedParticipant) {
  //     onModeChange('create');
  //   }
  // }, [selectedParticipant]);
  
  
  const [dialog, setDialog] = useState<{
    open: boolean;
    title: string;
    message: string;
    confirmButtonText: string;
    cancelButtonText?: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }>({
    open: false,
    title: "",
    message: "",
    confirmButtonText: "",
    onConfirm: () => {},
  });

  const closeDialog = () => {
    setDialog({
      open: false,
      title: "",
      message: "",
      confirmButtonText: "",
      onConfirm: () => {},
    });
  };

  useEffect(() => {
    const fetchUserInfo = () => {
      const userInfo = getUserInfo();
      if (userInfo) {
        setUser({
          fullName: userInfo.fullName || "Unknown User",
          email: userInfo.email || "",
        });
      }
    };
    fetchUserInfo();
  }, []);

  const createdBy = user ? `${user.email || user.fullName}` : "Unknown User";
  const modifiedBy = user ? `${user.email || user.fullName}` : "Unknown User";

  

  useEffect(() => {
    if (selectedParticipant && !isEditMode) {
      setParticipantLabel(selectedParticipant.participant_name);
      setParticipant_id(selectedParticipant.participant_id);
      setCompany_id(selectedParticipant.company_id);
      setSelectedCompany(selectedParticipant.company_name); 
      setAccountName(selectedParticipant.account_name);
      setSelectedIso(selectedParticipant.iso_code);
      setSelectedStatus(selectedParticipant.participant_status_code);
      setIsViewMode(true);
      onDirtyChange(false);
    } else if (selectedParticipant && isEditMode) {
      setParticipantLabel(selectedParticipant.participant_name);
      setParticipant_id(selectedParticipant.participant_id);
      setCompany_id(selectedParticipant.company_code);
      setSelectedCompany(selectedParticipant.company_name);
      setAccountName(selectedParticipant.account_name);
      setSelectedIso(selectedParticipant.iso_code);
      setSelectedStatus(selectedParticipant.participant_status_code);
      setIsEditMode(false);
      setIsViewMode(true);
    }
  }, [selectedParticipant]);
  
  
  const handleSubmit = () => {
    const isValid = validateFields();
    if (!isValid) {
      setDialog({
        open: true,
        title: PARTICIPANT_TAB.VALIDATION.MISSING_INFO_TITLE,
        message: PARTICIPANT_TAB.VALIDATION.MISSING_INFO_MESSAGE,
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
      return;
    }
    const participantData = {
      participant_name: participantLabel,
      company_id: company_id,
      company_name: selectedCompany, 
      account_name: accountName,
      participant_status_code: selectedStatus,
      iso_code: selectedIso,
      sys_created_by: createdBy,
      sys_modified_by: modifiedBy,
      participant_id:participant_id,
    };

    // if (isEditMode) {
    //   onSaveParticipant(participantData);
    //   closeDialog();
    //   resetForm();
    // } else {
    //   onCreateParticipant(participantData);
    //   closeDialog();
    //   resetForm();
    // }
    if (isEditMode) {
      setDialog({
        open: true,
       title: PARTICIPANT_TAB.DIALOGS.CONFIRM_EDIT_TITLE,
        message: PARTICIPANT_TAB.DIALOGS.CONFIRM_EDIT_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          onSaveParticipant(participantData);
          closeDialog();
          resetForm();
        },
        onCancel: closeDialog
      });
    } else {
      setDialog({
        open: true,
        title: PARTICIPANT_TAB.DIALOGS.CONFIRM_CREATE_TITLE,
        message: PARTICIPANT_TAB.DIALOGS.CONFIRM_CREATE_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          onCreateParticipant(participantData);
          closeDialog();
          resetForm();
        },
        onCancel: closeDialog
      });
    }
  };

  
  const resetForm = () => {
    setParticipantLabel('');
    setCompany_id('');
    setSelectedCompany('');
    setSelectedIso('');
    setAccountName('');
    setSelectedStatus('');
    setIsEditMode(false);
    setIsViewMode(false);
    onDirtyChange(false); 
    onModeChange(null);
    setModifiedFields({});
    // onClearSelection();
  };

  const handleEdit = () => {
    setIsViewMode(false);
    setIsEditMode(true);
    onDirtyChange(true); 
    onModeChange('edit');
    setModifiedFields({});
    console.log("Edit clicked"); 

  };
  const resetToSelectedCompany = () => {
    if (selectedParticipant) {
      setParticipantLabel(selectedParticipant.participant_name);
      setParticipant_id(selectedParticipant.participant_id);
      setCompany_id(selectedParticipant.company_id);
      setSelectedCompany(selectedParticipant.company_name); 
      setAccountName(selectedParticipant.account_name);
      setSelectedIso(selectedParticipant.iso_code);
      setSelectedStatus(selectedParticipant.participant_status_code);
      setModifiedFields({});
      setIsEditMode(false);
      setIsViewMode(true);
      onDirtyChange(false);
      onModeChange("view");
    }
  };
  
  const handleCancelClick = () => {
    setDialog({
      open: true,
      title: "Cancel Editing?",
      message: "Are you sure you want to discard changes?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetToSelectedCompany();
        setModifiedFields({});
      },
      onCancel: closeDialog,
    });
  };

  const handleNew = () => {
    setDialog({
      open: true,
      title: PARTICIPANT_TAB.DIALOGS.CONFIRM_NEW_TITLE,
      message: PARTICIPANT_TAB.DIALOGS.CONFIRM_NEW_MESSAGE,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetForm();
        // onModeChange('create');
        onDirtyChange(false);
        setIsEditMode(false); 
        onClearSelection();
      },
      onCancel: closeDialog,
    });
  };

  const handleDeleteClick = () => {
    if (!selectedParticipant) return;
  
    setDialog({
      open: true,
      title: "Confirm Delete",
      message: `Are you sure you want to delete "${selectedParticipant.participant_name}"?`,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        onDeleteParticipant(selectedParticipant.participant_id);
        closeDialog();
        resetForm();
      },
      onCancel: closeDialog,
    });
  };

  return (
    <div className="font-poppins w-full  mx-auto p-6 bg-white rounded-lg shadow-md overflow-visible">
      {dialog.open && (
        <Dialog
          title={dialog.title}
          message={dialog.message}
          confirmButtonText={dialog.confirmButtonText}
          cancelButtonText={dialog.cancelButtonText}
          onConfirm={dialog.onConfirm}
          onCancel={dialog.onCancel}
          onClose={closeDialog}
        />
      )}
<div className="flex justify-between items-center gap-4 mb-4">

<div>
  {isEditMode && canDelete && (
    <button
      onClick={handleDeleteClick}
      type="button"
      className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600"
    >
      <FaTrash className="w-4 h-4" />
      Delete
    </button>
  )}
</div>

<div className="flex gap-4">  {!isViewMode && !isEditMode && (
    <button
      onClick={handleSubmit}
      className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
    >
      <FaPlus className="w-4 h-4" />
      Create
    </button>
  )}

  {isViewMode && !isEditMode && (
    <>
      <button
        onClick={handleNew}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaPlus className="w-4 h-4" />
        New
      </button>

      <button
        onClick={handleEdit}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaEdit className="w-4 h-4" />
        Edit
      </button>
    </>
  )}

  {isEditMode && (
    <>
      <button
        onClick={handleSubmit}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        <FaSave className="w-4 h-4" />
        Save
      </button>

      <button
        onClick={handleCancelClick}
        className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
      >
        
        Cancel
      </button>
    </>
  )}
</div>
</div>

      {/* Form Fields */}
      <div className="flex flex-col gap-2 mt-5">
        <label className="block text-gray-600 mb- font-medium">Participant<span className="text-red-500 text-lg align-top ml-1">*</span></label>
        <input
          type="text"
          placeholder="Enter participant"
          value={participantLabel}
          // onChange={(e) => setParticipantLabel(e.target.value)}
          onChange={(e) => {
            setParticipantLabel(e.target.value);
            onDirtyChange(true); 
            setModifiedFields(prev => ({ ...prev, participantLabel: true }));
          }}
          onFocus={() => setActiveField("participantLabel")}
          disabled={isViewMode && !isEditMode}
          className={`w-68 p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 
          ${errors.participantLabel && !participantLabel
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "participantLabel"|| modifiedFields.participantLabel)
                ? "border-green-500 focus:ring-2 focus:ring-green-500"
                : !isEditMode
                  ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                  : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
            }`
          }
        />

      </div>
      

<div className="flex flex-col gap-2 mt-5">
  <label className="block text-gray-600 font-medium">Company<span className="text-red-500 text-lg align-top ml-1">*</span></label>
  <CompanyDropdown
    selectedCompany={selectedCompany}
    onCompanyChange={(companyName, companyId) => {
      setSelectedCompany(companyName); 
      setCompany_id(companyId.toString());
      onDirtyChange(true);
      setModifiedFields(prev => ({ ...prev, company_id: true }));
    }}
    onFocus={() => setActiveField("company_id")}
    disabled={isViewMode && !isEditMode}
    className={`w-68 p-1 border rounded-lg shadow-inner text-sm transition-all duration-200 
    ${errors.company_id && !company_id
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "company_id"|| modifiedFields.company_id)
                ? "border-green-500 focus:ring-2 focus:ring-green-500"
                : !isEditMode
                  ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                  : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
            }`
          }
        />
      </div>

<div className="flex flex-col gap-2 mt-5">
  <label className="block text-gray-600 mb- font-medium">Account Name<span className="text-red-500 text-lg align-top ml-1">*</span></label>
  <input
    type="text"
    placeholder="Enter Account Name"
    value={accountName}
    // onChange={(e) => setAccountName(e.target.value)}
    onChange={(e) => {
      setAccountName(e.target.value);
      onDirtyChange(true); 
      setModifiedFields(prev => ({ ...prev, accountName: true }));
    }}
    onFocus={() => setActiveField("accountName")}
    disabled={isViewMode && !isEditMode}
    className={`w-68 p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 
    ${errors.accountName && !accountName
      ? "border-red-500 focus:ring-red-500"
      : isEditMode && (activeField === "accountName"|| modifiedFields.accountName)
      ? "border-green-500 focus:ring-2 focus:ring-green-500"
      : !isEditMode
        ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
        : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
      }`
    }
  />
</div>


      <div className="flex flex-col gap-2 mt-5">
        <label className="block text-gray-600 mb-1">ISO<span className="text-red-500 text-lg align-top ml-1">*</span></label>
        <ISODropdown
          selectedISO={selectedIso}
          // onISOChange={(iso) => setSelectedIso(iso)}
          onISOChange={(iso) => {
            setSelectedIso(iso);
            onDirtyChange(true); 
            setModifiedFields(prev => ({ ...prev, selectedIso: true }));
          }}
          onFocus={() => setActiveField("selectedIso")}
          disabled={isViewMode && !isEditMode}
          className={`w-68 p-1 border rounded-lg shadow-inner text-sm transition-all duration-200
          ${errors.selectedIso && !selectedIso
            ? "border-red-500 focus:ring-red-500"
            : isEditMode && (activeField === "selectedIso"|| modifiedFields.selectedIso)
            ? "border-green-500 focus:ring-2 focus:ring-green-500"
            : !isEditMode
              ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
              : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
            }`
          }
        />
      </div>

        <div className="flex flex-col gap-2 mt-5">
          <label className="block text-gray-600 mb-1">Status<span className="text-red-500 text-lg align-top ml-1">*</span></label>
          <ParticipantStatusDropdown
            selectedStatus={selectedStatus}
            // onStatusChange={(status) => setSelectedStatus(status)}
            onStatusChange={(status) => {
              setSelectedStatus(status);
              onDirtyChange(true); 
              setModifiedFields(prev => ({ ...prev, selectedStatus: true }));
            }}
            onFocus={() => setActiveField("selectedStatus")}
            disabled={isViewMode && !isEditMode}
            className={`w-68 p-1 border rounded-lg shadow-inner text-sm transition-all duration-200
            ${errors.selectedStatus && !selectedStatus
              ? "border-red-500 focus:ring-red-500"
              : isEditMode && (activeField === "selectedStatus"|| modifiedFields.selectedStatus)
              ? "border-green-500 focus:ring-2 focus:ring-green-500"
              : !isEditMode
                ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`
            }
          />
      </div>

    </div>
  );
};

export default ParticipantForm;
